module.exports = __webpack_public_path__ + "img/noIe.2a689705.png";